module.exports = __webpack_public_path__ + "static/img/fullscreen-image_ready-made-reports.604c317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_ready-made-reports.png
// module id = 1pZV
// module chunks = 0